/**
 * Store de dispositivo con Zustand
 * Sprint 3 - Maneja el estado del dispositivo vinculado
 */

import { create } from 'zustand';
import { deviceService } from '../services';
import type { UserDevice } from '../types';

interface DeviceState {
    // Estado
    device: UserDevice | null;
    isInitialized: boolean;

    // Acciones
    setDevice: (device: UserDevice | null) => void;
    fetchDevice: () => Promise<void>;
    clearDevice: () => void;
}

export const useDeviceStore = create<DeviceState>((set) => ({
    // Estado inicial
    device: null,
    isInitialized: false,

    // Setear dispositivo (usado después de login/bind)
    setDevice: (device: UserDevice | null): void => {
        set({ device, isInitialized: true });
    },

    // Obtener dispositivo del servidor
    fetchDevice: async (): Promise<void> => {
        try {
            const response = await deviceService.getDeviceInfo();
            set({ device: response.data, isInitialized: true });
        } catch (error) {
            // Si falla, probablemente no hay dispositivo vinculado
            // Esto es esperado para usuarios nuevos (404) o sin autenticación (401)
            console.debug('📱 fetchDevice:', error instanceof Error ? error.message : 'No device found');
            set({ device: null, isInitialized: true });
        }
    },

    // Limpiar estado del dispositivo
    clearDevice: (): void => {
        set({ device: null, isInitialized: false });
    },
}));
